import { useOktaAuth } from "@okta/okta-react";
import React, { useEffect } from "react";
import { LoaderComponent } from "../loader/loader.component";
import { href } from "../../utils/ui-urls";

const Login = () => {
  const { authState, oktaAuth } =  useOktaAuth();

  const loginCallback = async () => {
    try {
      //Okta OIE new way of handling callback
      //It will parse and set tokens
      console.log("Before handleLoginRedirect");
      await oktaAuth.handleLoginRedirect();
      console.log("After handleLoginRedirect, Tokens parsed and set successfully...");

      console.log(
      "isAuthenticated after callback:",
      await oktaAuth.isAuthenticated()
    );

      // const { tokens } = await oktaAuth.token.parseFromUrl(); // remember to "await" this async call
      // await oktaAuth.tokenManager.setTokens(tokens);
      return;
    } catch (e) {
      console.log("Okta Callback Error");
      // log or display error details
    }
  };

  const authentication = async () => {
    console.log("authentication called");
    if (!(await oktaAuth.isAuthenticated())) {
      console.log("Not authenticated");
      // Start the browser based oidc flow, then parse tokens from the redirect callback url
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("authenticationfailed") == 'true') {
        await oktaAuth.signInWithRedirect({
          extraParams: {authenticationfailed: 'true'}
        });
      } else if (urlParams.get("UserAccountLocked") == 'true') {
        await oktaAuth.signInWithRedirect({
          extraParams: {UserAccountLocked: 'true'}
        });
      } else if (urlParams.get("missingauthentication") == 'true'){
        await oktaAuth.signInWithRedirect({
          extraParams: {error: 'true'}
        });
      } else if (urlParams.get("error") == 'access_denied'){
        window.location.replace(href.requestError)
      }
      else {
        await oktaAuth.signInWithRedirect();
      }
    } else {
      console.log("Redirecting to dashboard");
      window.location.replace(href.dashboard)
      // User is authenticated
    }
  }

  useEffect(() => {
    if (oktaAuth.isLoginRedirect()) {
      loginCallback()
    } else {
      authentication()
    }
  }, [])

  useEffect(() => {
    console.log("authState changed", authState);
    if(authState && authState?.isAuthenticated) {
      authentication()
    }  
  }, [authState])

  return (
    <div className="bg">
      <LoaderComponent />
    </div>
  );
};

export default Login;
